
import { useNavigate } from "react-router-dom";
import LocationSvg from "../../components/svg/LocationSvg";
import { FaPhone, FaGlobe, FaUsers } from "react-icons/fa";
import { DEFAULT_STORE_IMAGE } from "../../utils/constants";
import { MdDelete } from "react-icons/md";

const StoreLocationCard = ({ data, onDelete }) => {
  const navigate = useNavigate();

  return (
    <div
      className="xl:w-[33.3%] w-full md:w-[100%] lg:w-[50%] pr-3 pl-3 mb-5 cursor-pointer flex flex-col"
      onClick={() => navigate(`/panel/editlocation/${data?._id}`)}
    >
      <div className="card_top relative rounded-tl-[20px] rounded-tr-[20px] overflow-hidden">
        <div
          className="absolute w-full h-full"
          style={{
            backgroundImage:
              "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.0086472) 6.67%, rgba(1, 1, 2, 0.03551) 13.33%, rgba(2, 2, 4, 0.0816599) 20%, rgba(4, 3, 7, 0.147411) 26.67%, rgba(6, 5, 10, 0.231775) 33.33%, rgba(8, 7, 15, 0.331884) 40%, rgba(11, 9, 20, 0.442691) 46.67%, rgba(14, 11, 25, 0.557309) 53.33%, rgba(16, 13, 30, 0.668116) 60%, rgba(19, 15, 34, 0.768225) 66.67%, rgba(21, 17, 38, 0.852589) 73.33%, rgba(23, 18, 41, 0.91834) 80%, rgba(24, 19, 43, 0.96449) 86.67%, rgba(24, 20, 44, 0.991353) 93.33%, #19142D 100%)",
          }}
        ></div>
        <img
          src={data?.storeImage || DEFAULT_STORE_IMAGE}
          onError={(e) => { e.target.src = DEFAULT_STORE_IMAGE; }}
          alt={data?.title}
          className="w-full h-[240px] object-cover"
        />
        <div className="absolute top-2 left-0 pl-4 flex items-center gap-2">
          {data?.storePhoneNo && (
            <div className="py-[2px] px-2 bg-[#221C3FB2] text-white rounded-[60px] text-[12px] flex items-center gap-1">
              <FaPhone className="text-[10px]" />
              <span>{data?.storePhoneNo}</span>
            </div>
          )}
          {data?.volunteers && data?.volunteers.length > 0 && (
            <div className="py-[2px] px-2 bg-[#221C3FB2] text-white rounded-[60px] text-[12px] flex items-center gap-1">
              <FaUsers className="text-[10px]" />
              <span>{data?.volunteers.length} Volunteers</span>
            </div>
          )}
        </div>
        <div className="absolute bottom-2 left-0 pl-4 pr-4 w-full">
          <div className="mb-2 flex items-center justify-between">
            <h2 className="text-white text-[14px] lg:text-[18px] font-bold text-left">
              {data?.title}
            </h2>
          </div>
          {data?.storeUrl && (
            <div className="flex items-center gap-1 text-[#B8BBCC] text-[14px]">
              <FaGlobe className="text-[12px]" />
              <a
                href={data?.storeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#20FB92] hover:underline truncate"
                onClick={(e) => e.stopPropagation()}
              >
                Visit Website
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="sm:bg-[#211849] p-4 relative rounded-br-[20px] rounded-bl-[20px] bg-[#fff] sm:shadow-transparent shadow-lg flex-1">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center min-w-0 flex-1 gap-2">
            <LocationSvg width="14px" height="14px" />
            <span className="text-sm text-[#A4A1B2] w-0 flex-1 truncate text-left">
              {data?.locationName}
            </span>
          </div>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onDelete && onDelete(data._id); }}
            className="text-red-500 hover:text-red-400 transition-colors ml-2 flex-shrink-0"
            title="Delete store"
          >
            <MdDelete className="text-lg" />
          </button>
        </div>
        {data?.volunteers !== undefined && (
          <div className="mt-3">
            <p className="text-[12px] text-[#A4A1B2] mb-1 font-semibold text-left">
              Volunteers:{" "}
              {(!data.volunteers || data.volunteers.length === 0) && (
                <span className="font-normal">N/A</span>
              )}
            </p>
            {data.volunteers && data.volunteers.slice(0, 2).map((volunteer, index) => (
              <div key={index} className="flex items-start mb-1">
                <span className="text-[12px] text-[#B8BBCC]">
                  <span className="font-medium">{volunteer.displayName}</span>
                  {volunteer.roles && (
                    <span className="text-[#A4A1B2]"> - {volunteer.roles}</span>
                  )}
                </span>
              </div>
            ))}
            {data.volunteers && data.volunteers.length > 2 && (
              <p className="mt-1 text-[11px] text-[#B8BBCC] text-left font-medium">
                +{data.volunteers.length - 2} more{" "}
                {data.volunteers.length - 2 > 1 ? "volunteers" : "volunteer"}
              </p>
            )}
          </div>
        )}
        {data?.content && (
          <div className="mt-2">
            <p className="text-[12px] text-[#A4A1B2] line-clamp-2 text-left">
              {data?.content}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreLocationCard;
